export default "__VITE_PUBLIC_ASSET__c35acb14__"